import BusinessLocationsListContainer from "../../../components/asset-management/BusinessLocationsList";

export default function BusinessLocations() {
  return <BusinessLocationsListContainer />;
}
